// Design System
import { scrollToElement as designSystemScrollToElement } from 'jl-design-system/utils/scroll/scrollTo';

const DELAY_MSECS = 100;

function scrollToElement({
  config = {},
  focus = undefined,
  id,
  respectReducedMotion = false,
}: {
  config?: ScrollIntoViewOptions;
  focus?: boolean | string;
  id: string;
  respectReducedMotion?: boolean;
}) {
  window.setTimeout(() => {
    const selector = `[data-scroll="${id}"]`;
    const prefersReducedMotion =
      respectReducedMotion && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    designSystemScrollToElement(selector, focus, prefersReducedMotion ? { ...config, behavior: 'instant' } : config);
  }, DELAY_MSECS);

  return { type: 'SCROLL_TO_ELEMENT' };
}

export default scrollToElement;
